<template>
    <div>
        <div
            v-for="(item, index) in items"
            :key="index"
            class="decision-card"
        >
            <label
                :for="item.id"
                class="decision-card__wrapper"
                :class="{ selected: fields[item.code]}"
            >
                <div class="decision-card__content">
                    <div class="decision-card__details">
                        <div class="decision-card__title">
                            <input
                                v-model="fields[item.code]"
                                :id="item.id"
                                type="checkbox"
                                @input="onInput(item.code)"
                                class="checkbox"
                            >
                            <label :for="item.id">
                            </label>
                            {{ $t(item.title) }}
                        </div>
                        <div class="decision-card__text">{{ $t(item.description) }}</div>
                        <div
                            v-if="item.staticUrl"
                            class="decision-card__action"
                        >
                            <SubtleLinkExternal
                                :link="staticlink(item.staticUrl)"
                                target="_blank"
                            >
                                {{ $t('more information') | capitalize }}
                            </SubtleLinkExternal>
                        </div>
                    </div>
                    <Illustration
                        v-if="item.id !== 142 && !fields[item.code]"
                        :image="'/static/img/illustrations/bonus__' + item.title + '.svg'"
                    />
                    <Illustration
                        v-if="item.id !== 142 && fields[item.code]"
                        :image="'/static/img/illustrations/bonus__' + item.title + '-selected.svg'"
                    />
                </div>

            </label>
        </div>
        <div v-if="error">
            {{ $t(error) }}
        </div>
        <CustomButton
            :disabled="!hasChosen"
            :isLoading="isLoading"
            @click="onChooseBonusClick"
            class="btn btn btn__primary btn--block"
        >
            {{ $t('choose bonus') }}
        </CustomButton>
    </div>
</template>

<script>
    import {
        forEach as _forEach,
        some as _some,
    } from '@lodash';
    import { staticlink } from '@shared/filters';

    export default {
        name: 'WelcomeBonus',
        props: {
            isLoading: {
                type: Boolean,
                required: false,
                default: false,
            },
            error: {
                type: String,
                required: false,
            }
        },
        data() {
            return {
                items: [
                    {
                        id: 193,
                        code: 'SBWelcome',
                        title: 'sport',
                        description: 'First 3 deposits will get you bonuses of up to 500 lei',
                        staticUrl: 'bonus-bun-venit-sport'
                    },
                    {
                        id: 142,
                        code: 'NoBonus',
                        title: 'no bonus',
                        description: 'Reject all bonus choices',
                        staticUrl: '',
                    }
                ],
                fields: {
                    SBWelcome: false,
                    CasinoWelcome: false,
                    NoBonus: false,
                },
            };
        },
        created() {
            this.staticlink = staticlink;
        },
        computed: {
            hasChosen() {
                return _some(this.fields, Boolean);
            },
        },
        methods: {
            onInput(code) {
                _forEach(this.fields, (_, key) => {
                    if (key !== code) {
                        this.fields[key] = false;
                    }
                });
            },
            onChooseBonusClick() {
                _forEach(this.fields, (value, key) => {
                    if (value) {
                        this.$emit('chooseBonus', key);
                    }
                });
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/poland/app/modules/bonus/components/WelcomeBonus.vue